'use client'

// The footer newsletter email form — the DYNAMIC (interactive, Overmind-backed)
// slice carved out of the old client <Footer> for the #118 server-chrome refactor
// (Step 1). Everything else in the footer (nav columns, logo, trademark,
// copyright) is now the server <SiteFooter>; this island is the only part of that
// static shell that must ship client JS.
//
// It reads ONLY the newsletter state/actions through the narrow useNewsletterForm()
// selector (co-located read-seam), renders the email <Input> + submit
// <CtaLoading>, and shows the success/error <FooterEmailFormSubmittedAlert>
// snackbars. Markup + classNames are lifted VERBATIM from the old Footer so the
// rendered DOM is pixel-identical.

import React from 'react'
import Text from '../Text'
import Input from '../Input'
import CtaLoading from '../CtaLoading'
import FooterEmailFormSubmittedAlert from './FooterEmailFormSubmittedAlert'
import styles from './styles.module.css'
import { useNewsletterForm } from './useNewsletterForm'

function NewsletterFormIsland({ emailForm, textColor }) {
  const {
    email,
    isLoading,
    successMessage,
    errorMessage,
    setEmail,
    submit,
    resetStatusMessages,
  } = useNewsletterForm()

  return (
    <>
      <div className={styles.emailFormWrapper}>
        <Text type={'h5'} color={textColor}>{emailForm.text}</Text>
        <form className={styles.emailForm} onSubmit={(e) => {
            submit()
            e.preventDefault()
          }}
        >
          <Input
            size="xs"
            required
            type="email"
            placeholder={emailForm.inputPlaceholder}
            aria-label="Email address for newsletter subscription"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <CtaLoading
            primary
            title={emailForm.submitButtonText}
            type="submit"
            fullHeight
            isLoading={isLoading}
            disabled={isLoading}
          />
        </form>
      </div>
      <FooterEmailFormSubmittedAlert
        type="success"
        show={Boolean(successMessage)}
        message={successMessage}
        onClose={() => resetStatusMessages()}
      />
      <FooterEmailFormSubmittedAlert
        type="error"
        show={Boolean(errorMessage)}
        message={errorMessage}
        onClose={() => resetStatusMessages()}
      />
    </>
  )
}

export default NewsletterFormIsland
